const GlobeIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Terrain / origem */}
      <path
        d="M6 28c3-4 6.5-6 10-6s5.5 3 9 3 6-2 9-5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 32h30"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      {/* Pin */}
      <path
        d="M20 6c-3.6 0-6.5 2.9-6.5 6.5 0 4.8 6.5 11.5 6.5 11.5s6.5-6.7 6.5-11.5C26.5 8.9 23.6 6 20 6z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="12.5" r="2.2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export default GlobeIcon;
